import Groowtorial from '../groowtorial';

/**
 * Create the action
 */

const { thunk, request, success, error } = Groowtorial.index((fetch) => {
    return fetch.get('/groowtorials');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
